import Colors from "./Colors";
import { StyleSheet } from "react-native";

 const GlobalStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffffff",
    minWidth: 0
  },
  inputText: {
    height: 40,
    borderWidth: 1,
    width: '100%',
    borderRadius: 25,
    marginVertical: 5,
    backgroundColor: Colors.bgWhite,
    paddingHorizontal: 20,
    color: Colors.inputTextColor,
    fontSize: 14,
    borderColor: Colors.outLineInputText
  },

  multipleSelect: {
    minHeight: 40,
    borderWidth: 1,
    width: '100%',
    borderRadius: 25,
    marginVertical: 5,
    backgroundColor: Colors.bgWhite,
    paddingHorizontal: 20,
    color: Colors.inputTextColor,
    fontSize: 14,
    borderColor: Colors.outLineInputText
  },

  label: {
    color: Colors.labelColor,
    marginVertical: 2
  },

  label_12_semibold: {
    color: Colors.labelColor,
    fontSize: 12,
    fontWeight: "500"
  },

  label_13_semibold: {
    color: Colors.labelColor,
    fontSize: 13,
    fontWeight: "400"
  },

  label_12_bold: {
    color: Colors.labelColor,
    fontSize: 12,
    fontWeight: "bold"
  },

  label_13_bold: {
    color: Colors.labelColor,
    fontSize: 13,
    fontWeight: "bold"
  },

  label_16_bold: {
    color: Colors.labelColor,
    fontSize: 16,
    fontWeight: "bold"
  },


  label_12: {
    color: Colors.labelColor,
    fontSize: 12
  },

  label_13: {
    color: Colors.labelColor,
    fontSize: 13
  },

  labelError: {
    color: Colors.labelErrorColor,
    width: '100%'
  },

  labelForm: {
    color: Colors.labelColor,
    marginVertical: 4,
    fontWeight: "bold",
    fontSize: 13
  },



  title_22_bold: {
    color: Colors.labelColor,
    fontSize: 22,
    fontWeight: "bold"
  },
  title_16_bold: {
    color: Colors.labelColor,
    fontSize: 16,
    fontWeight: "bold"
  },

  button: {
    fontSize: 13
  },

  linkButton: {
    fontSize: 13,
    textDecorationLine: "underline",
    color: Colors.labelColor
  },

  horizontalContent: {
    flex: 0,
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    alignContent: "center"
  },

   horizontalContentTop: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "nowrap",
  },

  badge: {
    borderRadius: 12,
    backgroundColor: Colors.statusOpenColor,
    paddingHorizontal: 10,
    fontSize: 10,
    paddingVertical: 4,
    overflow: "hidden"
  },

  labelChips: {
    color: Colors.labelColor,
    fontWeight: "regular",
    fontSize: 12
  },

  chipMultiSelect: {
    marginHorizontal: 1,
    marginTop: 3,
    borderRadius: 20,
    borderColor: Colors.primary
  },

  labelSkillChips: {
    color: Colors.labelColor,
    fontWeight: "regular",
    fontSize: 12
  },

  chipSkills: {
    marginHorizontal: 1,
    marginTop: 3,
    borderRadius: 20,
    borderColor: Colors.greenButtonColor
  },

  linearHorizontal: {
    flex: 0,
    flexDirection: "row"
  },

  titleInner: {
    color: Colors.primary,
    fontSize: 16,
    fontWeight: "500"
  },

  /*BLUE TABLES HEADER*/
  tableHeaderContainer: {
    flex: 0,
    flexDirection: "row",
    backgroundColor: Colors.headerBlue,
    paddingVertical: 13,
    paddingHorizontal: 10,
    borderRadius: 30
  },
  tableItemContent: {
    flex: 0,
    flexDirection: "row",
    width: '100%',
    paddingVertical: 17,
    paddingHorizontal: 12,
    alignItems: "center"
  },
  tableTextHeader: {
    fontSize: 12,
    color: Colors.textWhite
  },

  textButtonUnderlined: {
    textDecorationLine: "underline",
    fontWeight: "normal",
    color: Colors.labelColor,
    fontSize: 12
  },

  badgeCandidate: {
    borderRadius: 10,
    backgroundColor: Colors.primary,
    paddingHorizontal: 2,
    fontSize: 10,
    paddingVertical: 4,
    overflow: "hidden",
    color: Colors.textWhite,
    textAlign: "center"
  },

  badgeCandidateInterview: {
    backgroundColor: Colors.primary
  },

  badgeCandidateRejected: {
    backgroundColor: Colors.statusCloseColor
  },

  badgeCandidateSend: {
    backgroundColor: Colors.statusOpenColor,
    color: Colors.labelColor
  },

  badgeCandidateDraft: {
    backgroundColor: Colors.statusDraftColor,
    color: Colors.labelColor
  },
});

export default GlobalStyles;
